import React, { FC } from "react";
import { useTheme } from "@material-ui/core";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

const GrossEarningsIcon: FC<SvgIconProps> = props => {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const secondary = theme.palette.secondary.main;

  return (
    <SvgIcon {...props} width="56" height="54" viewBox="0 0 56 54">
      <g
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <g stroke={primary}>
          <path
            d="M10 3L10.213 3.441M41 12.22L41.427 12"
            transform="translate(.5) translate(5 6)"
          />
          <path
            d="M3 11.22L3.427 11"
            transform="translate(.5) translate(5 6) matrix(-1 0 0 1 6.427 0)"
          />
          <path
            d="M33.213 3L33 3.441M22.107 0L22.107 1"
            transform="translate(.5) translate(5 6)"
          />
          <path
            d="M1 20.22L1.427 20"
            transform="translate(.5) translate(5 6) scale(-1 1) rotate(27.295 0 15.113)"
          />
          <path
            d="M3 29L3.213 29.441"
            transform="translate(.5) translate(5 6) scale(-1 1) rotate(-17.151 0 49.821)"
          />
          <path
            d="M11 39L11.213 39.441"
            transform="translate(.5) translate(5 6) scale(-1 1) rotate(-17.151 0 112.87)"
          />
        </g>
        <g>
          <path
            stroke={primary}
            d="M26.042 52C11.66 52 0 40.359 0 26S11.66 0 26.042 0c14.382 0 26.041 11.641 26.041 26"
            transform="translate(.5) translate(1 1)"
          />
          <g stroke={secondary}>
            <path
              d="M5.958 14.083C2.668 14.083 0 11.415 0 8.125s2.668-5.958 5.958-5.958 5.959 2.668 5.959 5.958M5.958 14.083c3.29 0 5.959 2.668 5.959 5.959 0 3.29-2.668 5.958-5.959 5.958C2.668 26 0 23.332 0 20.042M5.958 2.167L5.958 0M5.958 28.167L5.958 26"
              transform="translate(.5) translate(1 1) translate(20.583 11.917)"
            />
          </g>
          <path
            stroke={primary}
            d="M42.333 36.833L45.583 33.583 48.833 36.833"
            transform="translate(.5) translate(1 1)"
          />
          <path
            stroke={primary}
            d="M45.583 33.583v14.734s0 3.683-3.25 3.683"
            transform="translate(.5) translate(1 1)"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export default GrossEarningsIcon;
